import React, { useMemo } from 'react'

import S from '../styled'

import {
  StepsList,
  TranslatesModal,
} from  '../../../../components'

import StepDetails from './details'
import actions from './actions'

import listOptions from './listOptions'

import { findIngredient } from './utils'

const Steps = ({
  defaultLocale, locales,
  ingredients, appliances, appliance = appliances[0].id,
  model: variationsModel, field,
  freeAppliances, handleChangeAppliance,
  stepsSelector,
  locked,
}) => {

  const { model, values, onChange, isValidPath } = variationsModel

  const {
    handleTranslationChange,
    handleAddStep,
    handleChangeCategoryTranslate,
    showTranslatesModal,
    setShowTranslatesModal,
    handleSelectStep,
    selectedStep,
    handleDeleteStep,
    handleChangeOrder,
  } = actions({ onChange, model, field, appliance, stepsSelector, defaultLocale })

  const options = useMemo(() => {
    const findIngredientID = step => {
      const ingredientInfo = findIngredient(model, step, field)
      return ingredientInfo.ingredient ? ingredientInfo.ingredient.ingredientID : null
    }
    return listOptions({ defaultLocale, isValidPath, ingredients, findIngredientID })
  }, [model, field, ingredients, defaultLocale, isValidPath])

  return (
    <S.Steps>
      <S.StepsList>
        <StepsList
          values={values[field]}
          options={options}
          appliance={appliance}
          defaultLocale={defaultLocale}
          onAdd={handleAddStep}
          onSelect={handleSelectStep}
          selected={selectedStep}
          onDelete={handleDeleteStep}
          onChangeOrder={handleChangeOrder}
          readOnly={locked}
        />
      </S.StepsList>
      <StepDetails {...{
        selectedStep,
        handleTranslationChange,
        stepsModel: variationsModel,
        locales,
        defaultLocale,
        key: `${selectedStep}`,
        ingredients,
        appliances,
        appliance,
        field,
        locked,
      }}/>
      {
        showTranslatesModal && (
          <TranslatesModal
            translates={showTranslatesModal.translates}
            locales={locales}
            defaultLocale={defaultLocale}
            onClose={() => setShowTranslatesModal(null)}
            onChange={handleChangeCategoryTranslate}
          />
        )
      }
    </S.Steps>
  )
}

export default Steps
